import { OrderContents } from "../components/order-contents";
import { PaymentContents } from "../components/payment-contents";
import { StockOrderHead } from "../components";
import { useParams } from "react-router-dom";
import { useQuery } from "features/config/hooks";

export function StockOrderOrders() {
  const { view } = useParams();
  const query = useQuery();
  const tab = query.get("tab");

  return (
    <>
      <StockOrderHead
        StockOrderBreadCrumbsProps={{
          home: {
            title: "Home",
            url: `/admin/material/${view}${
              tab !== undefined ? `?tab=${tab}` : ""
            }`,
          },
          className: "lg:h-[200px]",
          pageTitles: [
            {
              name: view === "payments" ? "Payments" : view,
              url: `/admin/material/${view}${
                tab !== undefined ? `?tab=${tab}` : ""
              }`,
            },
          ],
        }}
      />
      <div className="p-1 md:p-8 font-[Roboto] ">
        {view === "payments" ? <PaymentContents /> : <OrderContents />}
      </div>
    </>
  );
}
